// PricingPhilosophy.js
import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

const PricingPhilosophy = () => {
  const beliefs = [
    'Every journey should begin with clarity',
    'Fees should reflect professional effort, not promises',
    'Clients should always know what they are paying for',
    'Payments should never be tied to admission or job outcomes'
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-8"
          >
            <h2 className="text-3xl md:text-4xl font-semibold text-[#202356] mb-4">
              Our Pricing Philosophy
            </h2>
            <p className="text-gray-600 text-base font-light leading-relaxed">
              Our services are consultation led and tailored to individual profiles. Pricing depends on the pathway, destination, and level of support required.
            </p>
          </motion.div>

          {/* Beliefs Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-[#F5F8FA] p-8 rounded-lg mb-6"
          >
            <p className="text-gray-700 text-base font-normal mb-6">
              We believe:
            </p>
            <div className="space-y-4">
              {beliefs.map((belief, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.3 + (index * 0.1) }}
                  className="flex items-start gap-3"
                >
                  <CheckCircle2 size={20} className="text-gray-700 flex-shrink-0 mt-0.5" />
                  <p className="text-gray-700 text-base font-light">
                    {belief}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Bottom Statement */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.7 }}
            className="text-center"
          >
            <p className="text-gray-700 text-base font-light leading-relaxed">
              All fees are explained clearly after consultation and before any payment is made.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PricingPhilosophy;
